// extracted by mini-css-extract-plugin
export default {"add":"control_add__wEu-W","tooltip":"control_tooltip__VtUCK"};